// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rXNN","question":"styles_question__8nrAJ","inputVisibleButton":"styles_inputVisibleButton__8Nv75","note":"styles_note__3DBbR"};